<template>
  <v-app>
    <router-view class="view" />
  </v-app>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  name: "App",
};
</script>

<style src="./assets/css/fontAwesome.css"></style>
<style src="./assets/css/Checkbox.css"></style>
<style src="./assets/css/common.css"></style>

<style></style>
